import { useContext, useEffect, useState } from 'react'
import { FileDnDContext } from '../file-dnd-context'

/**
 * A hook to attach a dropzone for the drag and drop of files to the FileDnDContext.
 *
 * @param {string} id - The identifier of the dropzone to update the currentHoveredDropzoneId value in the context
 * @param {function(DragEvent)} onFileDrop - Function witch is called if a file drop happened
 * @return {{onDrop: function, isOver: boolean, isDragging: boolean, onDragLeave: function, onDragEnter: function}}
 */
export function useFileDropzone({ id, onFileDrop }) {
    const [isOver, setIsOver] = useState(false)
    const { isDragging = false, setCurrentHoveredDropzoneId = Function.prototype } = useContext(FileDnDContext)

    useEffect(() => {
        if (isOver) {
            setCurrentHoveredDropzoneId(id)
        }
    }, [id, isOver, setCurrentHoveredDropzoneId])

    const onDragEnter = function () {
        setIsOver(true)
    }

    const onDragLeave = function () {
        setIsOver(false)
    }

    const onDrop = event => {
        if (!event.dataTransfer) {
            return
        }

        if (typeof onFileDrop === 'function') {
            onFileDrop(event)
            event.preventDefault()
        }
    }

    return { onDragEnter, onDragLeave, onDrop, isOver, isDragging }
}
